import { DeviceStatus } from '../../enums/device-status';
import { Registration } from '../registration';

export class Device {
    public imei: string;
    public appVersion: string;
    public started: Date;
    public finished: Date;
    public status: DeviceStatus;
    public batteryPercentage: number;
    public percentageCompleted: number;
    public percentageCompletedEarly: number;
    public percentageCompletedLate: number;
    public modifiedAt: Date;
    public registrations: Registration[];

    constructor();
    constructor(json: any);
    constructor(json?: Device) {
        if (json) {
            this.imei = json.imei;
            this.appVersion = json.appVersion;
            this.started = json.started;
            this.finished = json.finished;
            this.status = json.status;
            this.batteryPercentage = json.batteryPercentage;
            this.percentageCompleted = json.percentageCompleted;
            this.percentageCompletedEarly = json.percentageCompletedEarly;
            this.percentageCompletedLate = json.percentageCompletedLate;
            this.modifiedAt = json.modifiedAt;
            this.registrations = json.registrations;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/device.ts